import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-list',
  standalone: false,
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class MarginCalculatorListComponent implements OnInit {
  
  constructor() { }

  ngOnInit(): void {
  }

}
